import { Copy } from '../copy/Copy';

export const FOOTER_LIST_ITEMS = [
  {
    name: Copy.generate('FooterList.listItem.1'),
    to: '/privacy-policy',
  },
];
